module.exports = __webpack_public_path__ + "static/media/icon_carrosuspeito.950c9468.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_carrosuspeito.svg
// module id = 520
// module chunks = 0